// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CodeOutlinedSvg from "@ant-design/icons-svg/es/asn/CodeOutlined";
import AntdIcon from '../components/AntdIcon';

var CodeOutlined = function CodeOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CodeOutlinedSvg
  }));
};

CodeOutlined.displayName = 'CodeOutlined';
export default React.forwardRef(CodeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CodeOutlined.js
// module id = 815
// module chunks = 0